'use client';
import { FIBO_QUERIES } from '../../infrastructure/fibo/utils/queries';
import type { FiboSearchRequest } from '../../infrastructure/fibo/utils/types';
import { useQuery } from '@tanstack/react-query';

export const useFiboService = () => {
  const useFiboSearch = (params?: FiboSearchRequest) => {
    return useQuery(FIBO_QUERIES.getFiboSearch(params));
  };

  return {
    useFiboSearch,
  };
};
